import { render, staticRenderFns } from "./BrandCarousel.vue?vue&type=template&id=05dd9a76&"
import script from "./BrandCarousel.vue?vue&type=script&lang=ts&"
export * from "./BrandCarousel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports